/***
 *
 *   ACCOUNT NAV
 *   Acount sub nav that renders different options based
 *   on user permissions. Shows billing & user admin to only account owners
 *
 **********/

import React from "react";
import { SubNav } from "components/lib";

export function AccountNav(props) {
  // Sticky wrapper scoped to the account sub-nav only, so the tab menu stays
  // visible while scrolling any /account page. Scoped here (not in the shared
  // SubNav) so the verification-view SubNavs keep their existing behaviour.
  // Solid page-bg background so scrolled content doesn't show through.
  //
  // z-index 8 is deliberate and sits BELOW the fixed sidebar rail (9). At 20
  // this bar painted over the rail, so hovering the rail open showed the tab
  // menu straight through the expanded panel. It only ever needs to beat page
  // content (cards are 1), not the app chrome. Raising the rail instead would
  // push it above modal and loader scrims (10), which currently cover it
  // correctly — so the bar comes down rather than the rail going up.
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 8,
        background: "var(--sg-bg)",
      }}
    >
    <SubNav
      items={[
        { link: "/account/profile", label: "Profile" },
        { link: "/account/password", label: "Password" },
        { link: "/account/2fa", label: "2FA" },
        { link: "/account/billing", label: "Billing", permission: "owner" },
        {
          link: "/account/apikeys/",
          label: "API Keys",
          permission: "developer",
        },
        { link: "/account/users", label: "Users", permission: "admin" },
        { link: "/account/sanctions", label: "PEP/Sanctions", permission: "admin" },
        { link: "/account/ongoing-due-diligence", label: "Ongoing Due Diligence", permission: "admin" },
        { link: "/account/periodic-reviews", label: "Periodic Reviews", permission: "admin" },
        { link: "/account/ongoing-monitoring", label: "Ongoing Monitoring", permission: "admin" },
        {
          link: "/account/custom-emails",
          label: "Emails",
          permission: "admin",
        },
        {
          link: "/account/notifications",
          label: "Notifications",
          permission: "admin",
        },
        {
          link: "/account/integrations",
          label: "Integrations",
          permission: "admin",
        },
        {
          link: "/account/visibility",
          label: "Archive",
          permission: "admin",
        },
        {
          link: "/account/adverse-media",
          label: "Adverse Media",
          permission: "admin",
        },
        {
          link: "/account/reminders",
          label: "Reminders",
          permission: "admin",
        },
        {
          link: "/account/forms",
          label: "Forms",
          permission: "admin",
        },
        {
          link: "/account/post-form",
          label: "Post Verification Form",
          permission: "admin",
        },
      ]}
    />
    </div>
  );
}
